import { createCompanyPermission } from "../data/repository/company.repo";

export const CreateCompanyPermissionUseCase = async (
  permissions,
  companyId
) => {
  try {
    const resp = await createCompanyPermission(permissions, companyId);
    return resp.data;
  } catch (error) {
    console.log(error);
    return error.response.data;
  }
};
